import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ISidebarItem } from 'src/app/contracts';
import { Common } from 'src/app/contracts/translation/types';
import { BaseComponent } from '../base-component/base.component';

@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  imports: [RouterLink, TranslatePipe],
})
export class SidebarComponent extends BaseComponent implements OnInit {
  items: ISidebarItem[] = [];
  translationKeys: Common;
  constructor(private router: Router) {
    super();
    this.translationKeys = this.translation.Common;
  }
  override ngOnInit(): void {
    this.items = [
      { title: this.translationKeys.Home, icon: 'assets/images/sidebar/home.svg', route: '/' },
      { title: this.translationKeys.ManPowerRequests, icon: 'assets/images/sidebar/claims.svg', route: '/man-power' },
      { title: this.translationKeys.RecruitmentRequests, icon: 'assets/images/sidebar/contracts.svg', route: '/recruitment' },
      { title: this.translationKeys.Candidates, icon: 'assets/images/sidebar/employees.svg', route: '/candidates' },
    ];
  }
  selectItem(item: ISidebarItem) {
    this.router.navigate([item.route]);
  }
  isActive(item: ISidebarItem) {
    const url = window.location.toString().replace(window.location.origin, '');
    return url === item.route;
  }
}
